// EXPERIMENT: sign_form_signer_carousel_colors_experiment — remove with experiment cleanup
import type React from 'react';
import type { PropsWithChildren } from 'react';

import { useTreatSignerCarouselColorsExperiment } from '#src/app/pages/petitionDetails/shared/hooks';

import { CarouselSeenContext } from './carouselSeenContext';

export { CarouselSeenContext } from './carouselSeenContext';

/**
 * Hosts the carousel impression, treatment and `$exposure`, and hands the carousel its "seen" callback.
 *
 * Must be mounted exactly once, around both `MobileActionButton` mounts so they share one per-petition
 * guard, and above the sign modal: the carousel unmounts on modal close, on sign-form step 2 and after
 * signing, and a pending treat call must still be able to expose.
 */
export const SignerCarouselColorsTracking: React.FC<PropsWithChildren> = ({ children }) => {
	const reportCarouselSeen = useTreatSignerCarouselColorsExperiment();

	return <CarouselSeenContext.Provider value={reportCarouselSeen}>{children}</CarouselSeenContext.Provider>;
};
